import React from "react";

import { AlertTriangle } from "lucide-react";

import { Card, CardContent } from "~/components/ui/card";

interface ErrorStateProps {
  message: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message }) => {
  return (
    <Card className="border-red-200 bg-red-50">
      <CardContent className="flex items-center gap-2 pt-6 text-red-600">
        <AlertTriangle className="h-5 w-5" />
        <span>Error: {message}</span>
      </CardContent>
    </Card>
  );
};

export default ErrorState;
